<div class="row" *ngIf="(carrierLane | json) != '{}'">
    <div class="col-sm-12">
        <!--<div class="row">
        <div class="col">
            <label class="font-weight-bold">Mode</label>
            <select name="modeID" [(ngModel)]="modeID" (change)="modeChanged($event)" class="form-select" [ngClass]="(modeID==0) ? 'border border-danger' : ''" size="5" required>
                <option *ngFor="let mode of modeList" value="{{mode.modeID}}">{{mode.abbrev}} - {{mode.description}}</option>
            </select>
        </div>
    </div>
    <div class="row">
        <div class="col">
            <label class="font-weight-bold">Equipment Class</label>
            <select name="equipmentClassID" [(ngModel)]="equipmentClassID" (change)="equipmentClassChanged($event)" class="form-select" [ngClass]="(equipmentClassID==0) ? 'border border-danger' : ''" size="5" required>
                <option *ngFor="let item of equipmentClassList" value="{{item.equipmentClassID}}">[{{item.abbreviation}}] {{item.className}}</option>
            </select>
        </div>
    </div>
    <div class="row">
        <div class="col">
            <label class="font-weight-bold">Trailer</label>
            <select name="trailerTypeID" [(ngModel)]="trailerTypeID" (change)="trailerTypeChanged($event)" class="form-select" [ngClass]="(trailerTypeID==0) ? 'border border-danger' : ''" size="5" required>
                <option *ngFor="let trailerType of trailerTypeList" value="{{trailerType.trailerTypeID}}">{{trailerType.abbrev}} - {{trailerType.description}}</option>
            </select>
        </div>
    </div>-->
        <div class="row">
            <div class="col">
                <input type="checkbox" id="preferred" name="preferred" [(ngModel)]="carrierLane.preferred" [checked]="carrierLane.preferred" />
                <label class="font-weight-bold" for="preferred">Preferred</label>
            </div>
        </div>
        <div class="row">
            <div class="col">
                <label class="font-weight-bold">Rate/mi</label>
                <input type="number" id="ratePerMile" name="ratePerMile" class="form-control" [(ngModel)]="carrierLane.ratePerMile" />
            </div>
        </div>
        <!--<div class="row">
        <div class="col">
            <label class="font-weight-bold">Count</label>
            <input type="number" class="form-control" [(ngModel)]="carrierEquipment.equipmentCount" required />
        </div>
    </div>
    <div class="row">
        <div class="col">
            <label class="font-weight-bold">Length</label>
            <input type="number" class="form-control" [(ngModel)]="carrierEquipment.trailerLength" required />
        </div>
    </div>-->
        <div class="row">
            <div class="col m-2 text-end">
                <button class="btn btn-primary m-2" (click)="save()">Save</button>
                <button class="btn btn-secondary m-2" (click)="cancel()">Cancel</button>
            </div>
        </div>
    </div>
</div>

<div class="spinner_container dark-overlay" [ngClass]="{'dark-overlay': isLoading}">
    <mat-spinner style="left: 50%; top: 50%" *ngIf="isLoading"></mat-spinner>
</div>
